import { appNameMap } from '../constants/products';
/**
 * Determines the hosting application based on location or explicit ViewType
 * @param viewTypeOrPath - Optional ViewType to return directly, or pathname to determine ViewType from
 * @returns The ViewType specified, or determined from pathname, or undefined if not determinable
 */
export const getHostingApp = viewTypeOrPath => {
  var _a, _b;
  // If a valid ViewType is passed directly, return it
  if (viewTypeOrPath && Object.values(appNameMap).some(types => types[0] === viewTypeOrPath)) {
    return viewTypeOrPath;
  }
  // If we're in a server environment, we can't determine the app type
  if (typeof window === 'undefined') return undefined;
  // Use provided pathname or get it from window.location
  const pathname = typeof viewTypeOrPath === 'string' ? viewTypeOrPath : (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname) !== null && _b !== void 0 ? _b : '/';
  // Check each app's pathname pattern
  if (pathname === '/' || pathname.startsWith('/home') || pathname.startsWith('/hotels') || pathname.startsWith('/flights') || pathname.startsWith('/vacationpackages') || pathname.startsWith('/vip')) {
    return appNameMap['next-landing'][0];
  }
  if (pathname.startsWith('/relax')) {
    return pathname.includes('/at/') ? appNameMap['relax-at'][0] : appNameMap.relax[0];
  }
  if (pathname.startsWith('/m/fly/search')) {
    return appNameMap['fly-search'][0];
  }
  if (pathname.startsWith('/drive/landing') || pathname.startsWith('/rentalcars') || pathname.startsWith('/car-rentals') || pathname.startsWith('/rental-cars') || pathname.startsWith('/drive/search/r')) {
    return appNameMap['drive-search-responsive'][0];
  }
  if (pathname.startsWith('/cart/checkout')) {
    return appNameMap['cart-checkout'][0];
  }
  if (pathname.startsWith('/travel-itinerary')) {
    return appNameMap['travel-itinerary'][0];
  }
  return undefined;
};
export const getHostName = (IS_STORYBOOK, IS_CHROMATIC) => {
  var _a, _b, _c, _d;
  if (typeof window === 'undefined') return undefined;
  let hostname = IS_STORYBOOK ? 'localhost:8080' : (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) !== null && _b !== void 0 ? _b : 'www.priceline.com';
  hostname = IS_CHROMATIC ? 'www.priceline.com' : hostname;
  const protocol = (_d = (_c = window === null || window === void 0 ? void 0 : window.location) === null || _c === void 0 ? void 0 : _c.protocol) !== null && _d !== void 0 ? _d : 'https:';
  return hostname === 'localhost' ? 'http://localhost:8080' : `${protocol}//${hostname}`;
};